<template>
  <div>
    <transition name="fade" appear v-if="loading">
      <div class="overlay">
        <div class="topImage">
          <img class="laptop" :src="`${previewsServer}/textures/ui/new/laptop.jpg`">
          <img class="sticker" :src="`${previewsServer}/textures/ui/new/sticker.png`">
          <img class="arrow" :src="`${previewsServer}/textures/ui/new/pijl.png`">
          <img class="logo-inside" :src="`${previewsServer}/textures/ui/new/logo.png`">
        </div>
        <p class="title">WELKOM BIJ DE <span>TOPLAWOOD</span><br/>BUITENVERBLIJVEN-CONFIGURATOR</p>
        <div class="card">
          <h2>De configurator wordt geladen, een moment geduld a.u.b.</h2>

          <div class="progress-bar">
            <div class="progress-bar-progress" :style="`width: ${progress * 100}%;`"></div>
          </div>
        </div>
        <p class="tip"><span>TIP:</span> Gebruik de <span>desktopversie</span> van onze website voor de beste ervaring met onze configurator.</p>
        <img class="logo" :src="`${previewsServer}/textures/ui/new/logo.png`">
      </div>
    </transition>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER
      }
    },
    computed: {
      ...mapGetters({
        loading: 'getLoading',
        progress: 'getProgress'
      })
    },
  }
</script>

<style lang="scss" scoped>

.topImage {
  position: relative;
  display: inline-block;
}

.laptop {
  width: 777px;
  border-radius: 30px;
  display: block;
  @media (max-width: 999px) {
    display: none;
  }
}

.logo-inside {
  position: absolute;
  left: 16px;
  top: 16px;
  width: 215px;
  pointer-events: none;
  @media (max-width: 999px) {
    display: none;
  }
}

.sticker {
  position: absolute;
  bottom: 16px;
  right: 16px;
  width: 230px;
  pointer-events: none;
  @media (max-width: 999px) {
    position: inherit;
  }
}

.arrow {
  position: absolute;
  right: -20px;
  bottom: -145px;
  width: 200px;
  pointer-events: none;
  transform: scale(-1, 1);
  rotate: -110deg;
  @media (max-width: 999px) {
    display: none;
  }
}

.title {
  color: #57575B;
  font-family: 'Oswald', sans-serif;
  font-weight: 400;
  font-size: 40px;

  @media (max-width: 999px) {
    font-size: 28px;
  }

  span {
    font-family: 'Oswald', sans-serif;
    font-weight: 600;
  }
}

.tip {
  font-size: 20px;
  color: #57575B;
  font-weight: 300;
  display: none;

  @media (max-width: 999px) {
    display: block;
  }

  span {
    font-weight: 600;
  }
}

.logo {
  display: none;
  height: 119px;
  margin-top: 40px;
  @media (max-width: 999px) {
    display: inherit;
  }
}

h2 {
  margin: 0;
  font-size: 20px;
  color: #57575B;

  @media (max-width: 999px) {
    font-size: 18px;
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 98;
  min-height: 100vh;
  min-width: 100vw;
  overflow: hidden;
  background-color: rgb(255, 255, 255);
  pointer-events: all;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 25px;
  width: 578px;
  @media (max-width: 999px) {
    width: 310px;
  }
}

.progress-bar {
  border: 2px solid $c-border-1;
  border-radius: $radius-s;
  min-width: 100%;
  height: 15px;
  background-color: $c-background-1;
  display: flex;

  &-progress {
    transition: width 200ms ease;
    background-color: $c-secondary;
    height: 15px;
    border-radius: $radius-s;
  }
}

// overlay vue animation
.fade-enter-active,
.fade-leave-active {
  transition: opacity 250ms;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>